export function unlockAccountWithToken(send) {
  return (tokenId, ...args) =>
    send(
      {
        path: '/v1/tokens/{tokenId}/password/lockout',
        pathParameters: { tokenId },
        type: 'post',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: undefined,
        contentType: undefined,
      },
      ...args
    );
}
